import { Api } from "@mcleod/core";
import { AutogenLayoutProcessCommissionsPost } from "./autogen/AutogenLayoutProcessCommissionsPost";
import { CommissionsProcessStepperProps } from "./ProcessCommissionsStepper";

export class ProcessCommissionsPost extends AutogenLayoutProcessCommissionsPost {

    public async postCommissions(props: CommissionsProcessStepperProps) {
        const response = await Api.post("lme/settlement/commissions/post", {
                    begin_date: props.startDate,
                    end_date: props.endDate,
                    payees: props.payees
        });
        props.processLog?.refreshLastProcessedData();
        return response
    }
}
